import { React } from '../../../libraries'

const LoadingPackages = () => {
  return (
    <div className={`md:w-1/3 sm:w-1/2 w-4/5 md:mx-none mx-auto mt-0 lg:px-5 sm:px-2 sm:px-0 pr-5 sm:float-left flex-none`}>
      <div className="bg-white rounded-lg shadow-lg pb-5 animate">
        <h4 className="text-4xl mt-6">&nbsp;</h4>
        <p className="mb-2">&nbsp;</p>
        <div className="mt-1 mb-1 px-6 py-3 text-sm bg-gray-200">&nbsp;</div>
        <div className="mt-1 mb-1 px-6 py-3 text-sm">&nbsp;</div>
        <div className="mt-1 mb-1 px-6 py-3 text-sm bg-gray-200" style={{ color: '#CACCCF' }}>&nbsp;</div>
        <div className="mt-1 mb-1 px-6 py-3 text-sm" style={{ color: '#CACCCF' }}>&nbsp;</div>
        <div className="mt-1 mb-1 px-6 py-3 text-sm bg-gray-200" style={{ color: '#CACCCF' }}>&nbsp;</div>
        <div className="mt-3 mb-3 px-6 py-4 text-lg">&nbsp;</div>
        <div className="flex flex-wrap">
          <div className="text-center text-sm w-1/2 flex pl-6">
            <div className="w-full text-center text-white text-sm py-1">&nbsp;</div>
          </div>
          <div className="text-center text-sm w-1/2 pr-6">&nbsp;</div>
        </div>
      </div>
    </div>
  )
}

export default LoadingPackages